export default "__VITE_ASSET__BSUZiYHF__"